module.exports = __webpack_public_path__ + "img/材料力学6_1_5.e9f78d69.jpg";